import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import Switch from 'react-switch';
import CustomColumn from '../../../../customControl/CustomColumn'
import { ConfirmationModal } from '../../../../customControl/ConfirmationModal';
import CommonFilter from '../../../../customControl/CommonFilter';
import CustomTable from '../../../../customControl/CustomTable';
import { getAllData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { alphaSpace, formatDate } from '../../../commonClass/CommonValidation';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../_actions/loader.actions';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';

const CategoryName = ({ useradd, useredit, userexport }) => {
  const dispatch = useDispatch();
  const [actionType, setActionType] = useState('Add');
  const [modalShow, setModalShow] = useState(false);
  const [activeId, setActiveId] = useState();
  const [disabled, setDisabled] = useState(false);


  const [searchvalue, setSearchValue] = useState('');
  const [searchby, setSerachBy] = useState('All');
  const [searchDisabled, setSearchDisable] = useState(false);

  const [dataList, setDataList] = useState({});
  const [formValue, setFormValue] = useState({
    CategoryId: 0,
    CollectionId: 0,
    CategoryName: "",
    IsActive: false,
    UserId: 0
  });
  const [formError, setFormError] = useState({})

  const [isChange, setIsChange] = useState(true)
  const [CategoryNameList, SetCategoryNameList] = useState([]);
  const [filterList, setFilterList] = useState([]);

  const columns = [
    {
      name: 'Sr. No',
      key: 'srNo',
      sortable: true,
      reorder: true,
      selector: (data) => data?.srNo,
    },
    {
      name: 'Collection Name',
      key: 'CollectionName',
      sortable: true,
      reorder: true,
      selector: (data) => data?.CollectionName,
    },
    {
      name: 'Category Name',
      key: 'CategoryName',
      sortable: true,
      reorder: true,
      selector: (data) => data?.CategoryName,
    },
    {
      name: 'Active',
      key: 'ActiveTitle',
      sortable: true,
      reorder: true,
      selector: (data) => data?.ActiveTitle,
    },
    {
      name: 'Created Date',
      key: 'CreatedDateFormat',
      sortable: true,
      reorder: true,
      selector: (air) => new Date(air.CreatedDate),
      format: (data) => data.CreatedDateFormat,
    },
    {
      name: 'Edit',
      selector: (data) =>
        <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}>
          <i className="fa fa-edit" onClick={() => handleEditViewMode("Edit", data?.CategoryId)}>
          </i></button>
    },
    {
      name: 'View',
      selector: (data) => <i className="fa fa-eye cursor_pointer" onClick={() => handleEditViewMode("View", data?.CategoryId)}></i>
    }
  ]

  const getOptionAndList = async () => {
    dispatch(loaderActions.start())
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      const categoryList = await getAllData(`/master/v1/getallactivitycategorylist`);
      const callection = await getAllData(`/master/v1/activitycollectionlist`);

      const categoryData = categoryList?.data ?
        categoryList?.data?.map((cetagory, index) => (
          {
            ...cetagory,
            srNo: index + 1,
            ActiveTitle: cetagory?.IsActive ? "Active" : "InActive",
            CreatedDateFormat: formatDate(cetagory?.CreatedDate)
          }
        )) : []
      setDataList({
        callectionOption: callection?.data ? callection?.data : [],
        categoryList: categoryData
      });
      SetCategoryNameList(categoryData)
      setFilterList(categoryData)
      dispatch(loaderActions.end())
    }
    else {
      ClearLocalStorage();
      dispatch(loaderActions.end());
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
    }
  }

  useEffect(() => {
    getOptionAndList();
  }, [])

  const handleOnChange = (name, value) => {
    setFormValue({ ...formValue, [name]: value });
    setFormError({})
    setIsChange(false)
  }

  const handleisActive = (value) => {
    if (actionType === 'Add') {
      handleOnChange('IsActive', value)
    } else {
      setModalShow(true)
    }
  };

  const handleConfirmation = (action) => {
    if (action === true) {
      handleOnChange('IsActive', !formValue.IsActive)
    }
    setModalShow(false);
  }

  const handleEditViewMode = async (type, id) => {
    dispatch(loaderActions.start())
    setFormError({})
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      const category = await getAllData(`/master/v1/getactivitycategorybyid?CategoryId=${id}`);
      if (category.status) {
        setActionType(type);
        setIsChange(true);
        setFormValue({
          ...formValue,
          CategoryId: id,
          CollectionId: category.data?.[0].CollectionId,
          CategoryName: category.data?.[0]?.CategoryName,
          IsActive: category.data?.[0]?.IsActive,
          UserId: 0
        })
        dispatch(loaderActions.end());
      } else {
        dispatch(loaderActions.end());
        dispatch({ type: 'ALERTING', message: category.message })
      }
    } else {
      ClearLocalStorage();
      dispatch(loaderActions.end());
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
    }
  };

  const isValidData = () => {
    let errorMessage = {}
    let isError = false;

    if (formValue.CollectionId <= 0) {
      errorMessage = { ...errorMessage, 'CollectionId': 'Kindly Select The Collection Name.' }
      isError = true
    } else {
      if (!formValue.CategoryName || formValue.CategoryName?.trim()?.length <= 0) {
        errorMessage = { ...errorMessage, 'CategoryName': 'Kindly Enter Category Name.' }
        isError = true
      } else if (formValue.CategoryName.length > 100) {
        errorMessage = { ...errorMessage, 'CategoryName': 'Maximum character length: 100.' }
        isError = true
      } else if (filterList?.some((category) => category?.CategoryName?.trim() === formValue?.CategoryName?.trim() && category?.CollectionId === formValue?.CollectionId && category?.CategoryId !== formValue?.CategoryId)) {
        errorMessage = { ...errorMessage, 'CategoryName': 'Category name already exists.' }
        isError = true
      }
    }


    setFormError({ ...formError, ...errorMessage })
    return isError
  }

  const AddCategoryName = async () => {
    if (!isValidData()) {
      let statusoftoken = await verifytoken();
      if (statusoftoken) {
        let user = GetLocalStorage()
        const category = await postUsersData('/master/v1/insertorupdateactivitycategory', { ...formValue, UserId: user?.userMasterID });

        if (category?.status) {
          clearData();
          getOptionAndList();
          dispatch(loaderActions.end());
          dispatch({ type: 'ALERTING', message: category.message })
        }
        else {
          dispatch(loaderActions.end());
          dispatch({ type: 'ALERTING', message: category.message })
          return;
        }
      } else {
        ClearLocalStorage();
        dispatch(loaderActions.end());
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      }
    }
  }

  const clearData = () => {
    setFormValue({
      CategoryId: 0,
      CollectionId: 0,
      CategoryName: "",
      IsActive: false,
      UserId: 0
    })
    setActionType('Add')
    setFormError({})
  }
  return (
    <div className="container-fluid form_border py-5 my-3">
      <div className="row">

        <CustomColumn labelText='Select Collection' labelId='SelectCollectionId' isRequired >
          <Select
            className="dropdown select_dropdown"
            inputId='CollectionId'
            options={dataList?.callectionOption}
            isSearchable
            value={formValue.CollectionId > 0 ? dataList?.callectionOption.find((collection) => collection.value === Number(formValue.CollectionId)) : ""}
            isDisabled={disabled ? true : false || actionType === 'View' ? true : false}
            placeholder='Select Collection'
            onChange={(val) => { handleOnChange('CollectionId', val.value) }}
          />
          {formError.CollectionId && <p className='text-danger text-start'>{formError.CollectionId}</p>}
        </CustomColumn>

        <CustomColumn labelText='Category Name' labelId='CategoryName' isRequired >
          <input
            type="text"
            className='form-control'
            name="CategoryName"
            id="CategoryName"
            placeholder='Category Name'
            value={formValue.CategoryName}
            disabled={formValue.CollectionId <= 0 ? true : false || actionType === 'View' ? true : false}
            maxLength={100}
            onChange={(e) => { handleOnChange(e.target.name, alphaSpace(e.target.value)) }}
          />
          {formError.CategoryName && <p className='text-danger text-start'>{formError.CategoryName}</p>}
        </CustomColumn>


        <CustomColumn colNum={6} labelText='Active' labelId='Active'>
          <Switch
            onChange={handleisActive}
            checked={formValue.IsActive}
            className="react-switch"
            disabled={disabled ? true : false || actionType === 'View' ? true : false}
          />
          <ConfirmationModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            noconfirm={() => handleConfirmation(false)}
            yesconfirm={() => handleConfirmation(true)}
          />
        </CustomColumn>
      </div>

      <div className="d-flex justify-content-center mb-4">
        <button type="button" className="btn btn-primary mx-1"
          onClick={() => AddCategoryName()}
          disabled={isChange || (actionType === "Add" && !useradd)}
        >{actionType === 'Add' ? 'Add' : 'Update'}</button>
        <button type="button" className="btn btn-primary mx-1"
          onClick={() => clearData()}>Clear</button>
      </div>


      <CommonFilter
        columns={columns}
        filterList={filterList}
        searchDisabled={searchDisabled}
        getdata={getOptionAndList}
        setlistdata={SetCategoryNameList}
        searchvalue={searchvalue}
        setSearchValue={setSearchValue}
        searchby={searchby}
        setSerachBy={setSerachBy}
      />

      <div className="mt-4">
        <CustomTable
          className="last_two_column_freeze freezEditViewAtLast"
          columns={columns}
          data={CategoryNameList}
          disabled={!userexport}
          PdfExport={() => { }}
          ExportToExcel={() => { }}
        />
      </div>

    </div>
  )
}

export default CategoryName